<template>
    <div class="membership">
        <membership-search v-if="isAdmin" @selected="addUser" :url="membersUrl" :ignore="memberIds" :noResultsMessage=searchNoResultsMessage></membership-search>

        <template v-if="pendingMembers.length">
            <ul class="membership-list">
                <li class="membership-list__label page-main__section-subtitle">Pending Approval</li>
                <li class="membership-list__item" v-for="member in pendingMembers" :key="`member-${member.id}`">
                    <span class="membership-list__item-name">{{ member.name }}</span>
                    <span class="membership-list__item-actions">
                        <p>{{ member.id === user.id ? '(You)' : '' }}</p>
                        <div class="membership-list__item-actions-buttons">
                            <button class="element-button--secondary element-button" @click="addUser(member)">Approve</button>
                            <button class="element-button--secondary element-button" @click="removeUser(member)">Reject</button>
                        </div>
                    </span>
                </li>
            </ul>
            <hr />
        </template>
        <membership-list :user="user" :members="members" :isAdmin="isAdmin" @remove="removeUser" @promote="promoteUser" @demote="demoteUser"></membership-list>
    </div>
</template>

<script>
import _ from 'lodash'
import axios from 'axios'
import MembershipList from './MembershipList.vue'
import MembershipSearch from './MembershipSearch.vue'

export default {
    components: {
        MembershipList,
        MembershipSearch
    },
    props: {
        clientId: {
            type: Number
        },
        url: {
            type: String
        }, 
        user: {
            type: Object
        },
        isAdmin: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            members: []
        }
    },
    computed: {
        isAdminRole () {
            return this.$store.getters.isAdmin
        },
        membersUrl () {
            return this.clientId ? `/clients/${this.clientId}/membership` : (this.isAdminRole ? '/admin/users': '/users/search')
        },
        searchNoResultsMessage () {
            if (this.isAdminRole)
                return 'No results.'
            if (this.clientId)
                return 'User not found: Add user to client before adding to the project.'

            return 'User not found: Reach out to EYLearningExperienceAccelerator@ey.com.'
        },
        pendingMembers () {
            return _.filter(this.members, (member) => member.membership.role_code === 'pending')
        },
        memberIds () {
            return _.map(this.members, 'id')
        }
    },
    methods: {
        async getMembers () {
            try {
                const response = await axios.get(this.url)
                this.members = _.get(response, 'data.data.results')
            } catch (err) {
                console.error(err)
            }
        },
        async addUser (user) {
            const member = { [user.id]: 'member' }

            try {
                const response = await axios.post(this.url, { member })
                this.members = _.get(response, 'data.data.results')
            } catch (err) {
                console.error(err)
            }
        },
        async promoteUser (user) {
            const memberIndex = this.members.findIndex(member => member.id === user.id);
            if (memberIndex !== -1) {
                this.members[memberIndex].membership.role_code = 'owner';
                await this.updateMemberships(this.members)
            }
        },
        async demoteUser (user) {
            const memberIndex = this.members.findIndex(member => member.id === user.id);
            if (memberIndex !== -1) {
                this.members[memberIndex].membership.role_code = 'member';
                await this.updateMemberships(this.members)
            }
        },
        async updateMemberships (members) {
            try {
                this.members = members;

                const _data = { members: {} };
                _.forEach(this.members, member => {
                    _data.members[member.id] = member.membership.role_code;
                });

                const response = await axios.patch(this.url, _data);
                this.members = _.get(response, 'data.data.results')
            } catch (err) {
                console.error(err)
            }
        },
        async removeUser (user) {
            if (!confirm('Are you sure?')) {
                return
            }

            var index = _.findIndex(this.members, { id: user.id })
            if (index >= 0) {
                this.members.splice(index, 1)
            }

            try {
                const response = await axios.delete(this.url, { data: { member: user.id } })
                this.members = _.get(response, 'data.data.results')
            } catch (err) {
                console.error(err)
                // put em back
                this.members.splice(index, 0, user)
            }
        }
    },
    created () {
        this.getMembers()
    }
}
</script>
